import gql from "graphql-tag";

export const ItemWarehouseInfoFragment = gql`
  fragment ItemWarehouseInfo on ItemWarehouseInfoObjectType {
    itemCount
    location
    palletCount
  }
`;
